import React from 'react';

const FooterContact = () => (
  <div>
    <h4 className="text-lg font-semibold text-gold mb-4">Contact</h4>
    <div className="space-y-3">
      <div className="flex items-center space-x-2">
        <span className="text-gold">Phone:</span>
        <div>
          <p className="text-sm text-gray-300">Phone Numbers:</p>
          <p className="text-sm text-white">9496123189</p>
          <p className="text-sm text-white">9847103672</p>
          <p className="text-sm text-white">9400605057</p>
        </div>
      </div>
      
      <div className="flex items-start space-x-2">
        <span className="text-gold">Hours:</span>
        <div>
          <p className="text-sm text-gray-300">Temple Timings:</p>
          <p className="text-sm text-white">Morning: 5:30 AM - 10:45 AM</p>
          <p className="text-sm text-white">Evening: 5:30 PM - 8:00 PM</p>
        </div>
      </div>

      <div className="flex items-start space-x-2">
        <span className="text-gold">Bank:</span>
        <div>
          <p className="text-sm text-gray-300">Bank Details:</p>
          <p className="text-xs text-white">SREE KRISHNASWAMY DEVASWOM</p>
          <p className="text-xs text-white">BANK OF BARODA</p>
          <p className="text-xs text-white">A/C: 62790200001260</p>
          <p className="text-xs text-white">IFSC: BARB0VJKOGR</p>
          <p className="text-xs text-gray-400">(Fifth character is zero)</p>
        </div>
      </div>
      
      <div className="flex items-start space-x-2">
        <span className="text-gold">Festival:</span>
        <div>
          <p className="text-sm text-gray-300">Annual Mahotsavam:</p>
          <p className="text-xs text-white">Phalguna month (Feb-March)</p>
          <p className="text-xs text-white">8 days: Karthika to Makam star</p>
        </div>
      </div>
    </div>
  </div>
);

export default FooterContact;
